module.exports = __webpack_public_path__ + "media/images/advisor/img_5_0-fd2bd3c044fe4abac606120f6ba99938.png";